import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from 'containers/Modals/Modal';
import GroupAssignmentForm from 'containers/Forms/AssignmentForm/AssignmentForm';
import AssignmentForm from 'containers/Forms/AssignmentForm/MultipleAssignmentForm';
import { Button, Icon, translate } from '@haldor/ui';

var CreateAssignment = /*#__PURE__*/function (_Component) {
  _inherits(CreateAssignment, _Component);

  var _super = _createSuper(CreateAssignment);

  function CreateAssignment(props) {
    var _this;

    _classCallCheck(this, CreateAssignment);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggleRegular", function (event) {
      if (event != null) {
        event.preventDefault();
      }

      _this.setState({
        regular: !_this.state.regular
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleGroup", function (event) {
      if (event != null) {
        event.preventDefault();
      }

      _this.setState({
        group: !_this.state.group
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onAssignmentCreated", function (created) {
      if (created) {
        _this.props.onCreated(_this.props.createdAssignments);
      }

      _this.setState({
        regular: !_this.state.regular
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onGroupAssignmentCreate", function (assignment) {
      if (assignment != null) {
        _this.props.onCreated([assignment]);
      }

      _this.setState({
        group: !_this.state.group
      });
    });

    _this.state = {
      regular: false,
      group: false
    };
    return _this;
  }

  _createClass(CreateAssignment, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      if (!this.props.services.haldor) {
        // Shouldnt be able to create assignments if customer doesnt have service for haldor assignments
        return null;
      }

      var section = null;

      if (this.props.selectedSections != null && this.props.selectedSections.length > 0) {
        section = this.props.selectedSections[0];
      } else {
        section = this.props.activeSection;
      }

      if (section == null) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'inline-block',
          marginLeft: '.55rem'
        }
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.regular,
        onClose: this.toggleRegular,
        title: this.props.translate('task-create-button')
      }, /*#__PURE__*/React.createElement(AssignmentForm, {
        onAbort: this.onAssignmentCreated,
        editView: false,
        cloneView: false,
        groupid: section.id,
        section: section,
        disablePlanSelector: true,
        planningAssessments: this.props.planningAssessments,
        existingPlanningAssessments: true
      })), /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.group,
        onClose: this.toggleGroup,
        title: this.props.translate('create-group-assignment')
      }, /*#__PURE__*/React.createElement(GroupAssignmentForm, {
        editView: false,
        cloneView: false,
        groupid: section.id,
        onAbort: function onAbort() {
          return _this2.setState({
            group: false
          });
        },
        onCreated: this.onGroupAssignmentCreate,
        disablePlanSelector: true,
        existingPlanningAssessments: true,
        planningAssessments: this.props.planningAssessments
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.toggleRegular
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plus"
      }), this.props.translate('Create assignment')), /*#__PURE__*/React.createElement(Button, {
        style: {
          marginLeft: '.55rem'
        },
        onClick: this.toggleGroup
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plus"
      }), this.props.translate('Create group assignment'))));
    }
  }]);

  return CreateAssignment;
}(Component);

function mapStateToProps(state) {
  return {
    services: state.Services.availableServices,
    translate: translate(state.Languages.translations),
    createdAssignments: state.assignments.newAssignments,
    createdGroupAssignment: state.assignments.newAssignment,
    activeSection: state.sections.activeSection,
    selectedSections: state.sections.selected
  };
}

export default connect(mapStateToProps)(CreateAssignment);